import Page from '../page';
import FormValidator from '../../helpers/form-validator';
import UploadManager from "../../helpers/upload-manager";

export default class ContactIndex extends Page {
    constructor(...args) {
        super(...args);

        this._action = 'pathe_contact';

        this._retrieveDOM();
    }

    _retrieveDOM() {
        super._retrieveDOM();

        this.dom.form = this.dom.page.querySelector( '.js-form' );
        this.dom.inputs = this.dom.form.querySelectorAll( '.js-input' );
        this.dom.validate = this.dom.form.querySelector( '.js-validate' );
        this.dom.actions = this.dom.page.querySelector( '.js-actions-form' );
        this.dom.questions_wrapper = this.dom.form.querySelector( '.js-choices' );
        this.dom.countries_wrapper = this.dom.form.querySelector( '.js-countries-wrapper' );
        this.dom.questions_choice = this.dom.questions_wrapper.querySelectorAll( '[data-answer]' );
        this.dom.optionnal_wrappers = this.dom.form.querySelectorAll( '[data-e-ticket]' );
        this.dom.tickets_wrappers = this.dom.form.querySelectorAll( '[data-country] ' );
        this.dom.contactBlock = this.dom.page.querySelectorAll('.ct--contact-block');

        /** Selects **/
        this.dom.select_country = this.dom.page.querySelector( '.js-countries select' );
        this._country_selected = null;
        this.dom.select_service = this.dom.page.querySelector( '.js-services select' );
        this._service_selected = null;
        this.dom.select_civility = this.dom.page.querySelector( '.js-civility select' );
        this._civility_selected = null;

        /** Upload **/
        this._upload = this.dom.form.querySelector('.input-file');

        /** ReCaptcha **/
        this._captchaContainer = document.getElementById('container-captcha');
    }

    init() {
        super.init();

        this._is_process = false;

        /** Init Form Validator **/
        this._Validator = new FormValidator({
            'inputs' : this.dom.inputs,
            'parent' : false
        });

        /** Init File upload **/
        var uploadsOpts = {
            uploads : {
                upload: {
                    input: this._upload,
                    maxSize: 4,
                    type: ['application/pdf', 'image/jpeg', 'image/png'],
                    label: this.dom.form.querySelector('label[for="file"]'),
                    required: false,
                }
            }
        }
        this.UploadManager = new UploadManager(uploadsOpts);


        /** Init ReCaptcha **/
        this._captchaScript = document.createElement('script');
        this._captchaScript.src = 'https://www.google.com/recaptcha/api.js?hl=' + this._captchaContainer.getAttribute('data-captcha-lang');
        this._captchaContainer.appendChild( this._captchaScript );
    }

    bind() {
        super.bind();

        // Ticket issue answer
        if( this.dom.questions_choice ) {
            for( var i = 0, j = this.dom.questions_choice.length; i < j; i++ )
            {
                this.dom.questions_choice[i].addEventListener( 'click', (e) => {
                    this._showSteps(e.currentTarget);
                });
            }
        }

        // Select Country
        if( this.dom.select_country ) {
            this.dom.select_country.addEventListener( 'change', () => {
                if( this.dom.select_country.value )
                    this._country_selected = this.dom.select_country.value;
                else {
                    this._country_selected = null
                }

                this._toggleTicketsByCountry();
            });
        }

        // Select Service
        if( this.dom.select_service ) {
            this.dom.select_service.addEventListener( 'change', () => {
                if( this.dom.select_service.value ) {
                    this.dom.select_service.parentNode.parentNode.classList.remove('error');
                    this._service_selected = this.dom.select_service.value;
                } else {
                    this.dom.select_service.parentNode.parentNode.classList.add('error');
                    this._service_selected = null;
                }
            });
        }

        // Select Civility
        if( this.dom.select_civility ) {
            // Get default value
            if( this.dom.select_civility.value )
                this._civility_selected = this.dom.select_civility.value;
            // Bind change
            this.dom.select_civility.addEventListener( 'change', () => {
                if( this.dom.select_civility.value ) {
                    this.dom.select_civility.parentNode.parentNode.classList.remove('error');
                    this._civility_selected = this.dom.select_civility.value;
                } else {
                    this.dom.select_civility.parentNode.parentNode.classList.add('error');
                    this._civility_selected = null;
                }
            });
        }

        // Validate Form
        this.dom.validate.addEventListener( 'click', this._validate.bind(this) );
    }

    _showSteps( choice ) {
        console.log('Show Steps', choice.getAttribute('data-answer'));

        this.dom.contactBlock.forEach(element => {
            element.classList.remove('active');
        });
        if (choice.getAttribute('data-answer') == 'true') {
            this.dom.contactBlock[1].classList.add('active');
        } else {
            this.dom.contactBlock[0].classList.add('active');
            this.dom.contactBlock[2].classList.add('active');
        }


        // Manage active class
        for( var i =0, j = this.dom.questions_choice.length; i < j; i++ )
        {
            this.dom.questions_choice[i].classList.remove( 'active' );
        }
        choice.classList.add( 'active' );

        // Show steps of answer
        var answer = choice.getAttribute( 'data-answer' );
        if( answer == 'true' ) {
            this.dom.countries_wrapper.classList.remove ('hide');
            for( var i = 0, j = this.dom.optionnal_wrappers.length; i < j; i++ ) {
                if( this.dom.optionnal_wrappers[i].getAttribute( 'data-e-ticket' ) == 'show' )
                    this.dom.optionnal_wrappers[i].classList.remove( 'hide' );
                else
                    this.dom.optionnal_wrappers[i].classList.add( 'hide' );
            }
        } else {
            this.dom.countries_wrapper.classList.add ('hide');
            for( var i = 0, j = this.dom.optionnal_wrappers.length; i < j; i++ ) {
                if( this.dom.optionnal_wrappers[i].getAttribute( 'data-e-ticket' ) == 'hide' ){
                    this.dom.optionnal_wrappers[i].classList.remove( 'hide' );
                    this.dom.optionnal_wrappers[i].classList.remove( 'hide-from-country' );
                }
                else
                    this.dom.optionnal_wrappers[i].classList.add( 'hide' );
            }
        }
    }

    _toggleTicketsByCountry() {
        this.dom.optionnal_wrappers.forEach(element => {
            element.classList.remove('hide-from-country')
        });

        if( this._country_selected == null ) {

            // Hide all if country is reset
            for( var i = 0, j = this.dom.tickets_wrappers.length; i < j; i++ ) {
                this.dom.tickets_wrappers[i].classList.add('hide');
            }

            this.dom.questions_wrapper.classList.add('hide');

            for( var i = 0, j = this.dom.optionnal_wrappers.length; i < j; i++ ) {
                this.dom.optionnal_wrappers[i].classList.add( 'hide' );
            }

        }  else {
            // Show specified country content
            for( var i = 0, j = this.dom.tickets_wrappers.length; i < j; i++ ) {
                if( this.dom.tickets_wrappers[i].getAttribute( 'data-country' ) == this._country_selected )
                    this.dom.tickets_wrappers[i].classList.remove( 'hide' );
                else
                    this.dom.tickets_wrappers[i].classList.add( 'hide' );
            }
            this.dom.questions_wrapper.classList.remove('hide');
        }
    }


    _validate() {

        var errors = [];

        // Check process
        if( this._is_process == false ) {

            this._is_process = true;
            document.body.classList.add( 'loading' );
            this.dom.validate.classList.add( 'loading' );

            var data = new FormData();

            // Check Service
            if( this._service_selected ) {
                data.append('subject', this._service_selected);
                this.dom.select_service.parentNode.parentNode.classList.remove('error');
            } else {
                this.dom.select_service.parentNode.parentNode.classList.add('error');
                errors.push( 'Service not valid' );
            }

            // Check Civility
            if( this._civility_selected ) {
                data.append('civility', this._civility_selected);
                this.dom.select_civility.parentNode.parentNode.classList.remove('error');
            } else {
                this.dom.select_civility.parentNode.parentNode.classList.add('error');
                errors.push( 'Civility not valid' );
            }

            // Check Form inputs
            if( this._Validator.isValid() ) {
                // Get Form Fields data
                var inputs = this._Validator.getData();
                for(var item in inputs) {
                    data.append(item, inputs[item]);
                }

            } else {
                errors.push( 'Form not valid' );
            }

            // Check Upload
            if( this.UploadManager.getFiles() ) {
                data.append('upload', this.UploadManager.getFilesValues()['upload']);
            } else {
                errors.push( 'Upload not valid' );
            }

            // RECAPTCHA
            this._captcha = document.getElementById("g-recaptcha-response");
            if( this._captcha.value != '' ) {
                this._captchaContainer.classList.remove( 'error' );
                data.append('recaptcha', this._captcha.value);
            } else {
                this._captchaContainer.classList.add( 'error' );
                errors.push( 'Wrong reCaptcha' );
            }

            // Check errors
            if( errors.length > 0 ) {

                this._is_process = false;
                document.body.classList.remove( 'loading' );
                this.dom.validate.classList.remove( 'loading' );

                return;
            }

            // Request
            this._request( data );
        }

    }


    _request( data ) {

        const xhr = new XMLHttpRequest();
        xhr.open( 'POST', '/ajax.php?action=' + this._action, true );
        xhr.onreadystatechange = function () {
            if( xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200 ) {
                this._response(( JSON.parse( xhr.response )));
            }
            this._is_process = false;
            document.body.classList.remove( 'loading' );
            this.dom.validate.classList.remove( 'loading' );
        }.bind( this );
        xhr.send( data );
    }

    _response( response ) {
        this.dom.actions.classList.add( 'succeed' );
    }

    /**
     * init() {}
     * bind() {}
     * unbind() {}
     * resize(width, height) {}
     * _destroy() {}
     */
}



// WEBPACK FOOTER //
// src/js/pages/contact/contact.js